/**
 * Janela de busca de vistorias e manutenções de uma locação para o laudo.
 *
 * Com hora na retirada e na devolução, o período é o instante exato com uma folga de duas horas em cada
 * ponta: a vistoria de saída é feita minutos antes da retirada e a de entrada minutos depois da devolução.
 * Término gravado sem hora (locação antiga, meia-noite) vale até o fim do dia. Sem o corte na hora, a
 * vistoria de entrada do locatário seguinte no mesmo dia entraria no laudo errado.
 */
export const MARGEM_PERIODO_MS = 2 * 60 * 60 * 1000;

export const fimDoDia = (data: Date): Date => {
    const d = new Date(data);
    d.setHours(23, 59, 59, 999);
    return d;
};

export const janelaDaLocacao = (
    dataInicio: string | Date,
    dataTermino?: string | Date | null,
    agora: Date = new Date()
): { inicio: Date; fim: Date } => {
    const inicio = new Date(new Date(dataInicio).getTime() - MARGEM_PERIODO_MS);
    if (!dataTermino) return { inicio, fim: agora };
    const termino = new Date(dataTermino);
    const semHora = termino.getHours() === 0 && termino.getMinutes() === 0 && termino.getSeconds() === 0;
    const fim = semHora ? fimDoDia(termino) : new Date(termino.getTime() + MARGEM_PERIODO_MS);
    return { inicio, fim };
};
